// extracted by mini-css-extract-plugin
export default {"title":"MatchPairsAnswerOption_title__1SHei","sidesDivider":"MatchPairsAnswerOption_sidesDivider__1sO5d","sideContainer":"MatchPairsAnswerOption_sideContainer__erexJ"};